import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "placeholder-container" }
const _hoisted_2 = { class: "placeholder-content" }
const _hoisted_3 = { class: "placeholder-title" }
const _hoisted_4 = { class: "placeholder-description" }

import { Tools } from '@element-plus/icons'

interface Props {
  title: string
  description?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EVPlaceholder',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_icon, {
        size: 120,
        class: "placeholder-icon"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Tools))
        ]),
        _: 1
      }),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1),
      _createVNode(_component_el_tag, {
        type: "info",
        class: "status-tag"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Under Development ")
        ])),
        _: 1,
        __: [0]
      })
    ])
  ]))
}
}

})